import { AgentGrounding } from '@d-id/types';
import { ListItem, ListItemButton } from '@mui/material';
import { GroundingOption } from './GroundingOption';
import { GroundingStateItem } from './GroundingSelection';

interface Props {
    onSelect: (groundingState: AgentGrounding) => void;
    item: GroundingStateItem;
}

export const GroundingListItem = ({ item, onSelect }: Props) => {
    return (
        <ListItem disablePadding onClick={() => onSelect(item.groundingState)}>
            <ListItemButton>
                <GroundingOption item={item} />
            </ListItemButton>
        </ListItem>
    );
};
